export const cancellationMockDate = '3999-12-31';
export const cancellationMockDateHu = '3999.12.31.';
